module.exports = __webpack_public_path__ + "img/close.4bdd6b4a.png";